exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-2294e40f]{display:flex;align-items:center;justify-content:center;z-index:1000}.modal-card[data-v-2294e40f]{width:80%;max-width:600px}.modal-card-head[data-v-2294e40f]{background-color:#f5f5f5}.modal-card-body[data-v-2294e40f]{padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2294e40f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sasisopa/ChangeRequests.vue
// module id = 4088
// module chunks = 0